// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Theme-aware palette (2026-08-13): the Setup lenses were hardcoded to
   dark-mode whites and vanished in light mode. Component vars, dark values
   under :host-context(.dark) — matches the app's :root.dark switching. */
:host {
  --lens-fg: rgba(0, 0, 0, 0.87);
  --lens-fg-soft: rgba(0, 0, 0, 0.55);
  --lens-fg-faint: rgba(0, 0, 0, 0.38);
  --lens-hover-bg: rgba(0, 0, 0, 0.05);
  --lens-line: rgba(0, 0, 0, 0.12);
  --lens-surface: rgba(0, 0, 0, 0.025);
}

:host-context(.dark) {
  --lens-fg: rgba(255, 255, 255, 0.92);
  --lens-fg-soft: rgba(255, 255, 255, 0.55);
  --lens-fg-faint: rgba(255, 255, 255, 0.38);
  --lens-hover-bg: rgba(255, 255, 255, 0.06);
  --lens-line: rgba(255, 255, 255, 0.12);
  --lens-surface: rgba(255, 255, 255, 0.03);
}

:host {
  display: block;
}

.setup-item {
  border: 1px solid var(--lens-line);
  border-radius: 12px;
  padding: 18px 20px;
  background: var(--lens-surface);
  transition: border-color 0.2s ease;
}
.setup-item.complete {
  border-color: rgba(102, 187, 106, 0.35);
  background: rgba(102, 187, 106, 0.04);
}

.setup-item-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.setup-item-header .status-icon {
  color: #66bb6a;
  flex: 0 0 auto;
}
.setup-item-header .setup-item-info {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
}
.setup-item-header .setup-item-title {
  font-weight: 600;
  font-size: 15px;
  color: var(--lens-fg);
}
.setup-item-header .setup-item-status {
  font-size: 12.5px;
  color: var(--lens-fg-soft);
}

.agent-rows {
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.agent-row {
  /* name (fills) | badge lane (fixed) | dropdown lane (fixed) — keeps badges and
     dropdowns aligned in vertical columns across every row. */
  display: grid;
  grid-template-columns: minmax(0, 1fr) 100px 160px 180px auto;
  align-items: center;
  gap: 12px;
  border: 1px solid var(--lens-line);
  border-radius: 10px;
  padding: 10px 14px;
  background: var(--lens-surface);
  /* Explicit lane placement so a hidden badge (subscription rows) leaves its
     column empty rather than collapsing and shifting the dropdowns left. */
}
.agent-row .agent-id {
  grid-column: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.agent-row .agent-name {
  font-weight: 600;
  font-size: 14px;
  color: var(--lens-fg);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.agent-row .agent-sub {
  font-size: 11px;
  color: var(--lens-fg-faint);
  font-family: ui-monospace, "SF Mono", Menlo, monospace;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.agent-row .backend-hint {
  color: rgba(144, 202, 249, 0.65);
}
.agent-row > .mode-badge {
  grid-column: 2;
  justify-self: end;
}
.agent-row .model-select {
  grid-column: 3;
}
.agent-row .agent-binding {
  grid-column: 4;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
.agent-row .agent-actions {
  grid-column: 5;
  display: flex;
  gap: 4px;
}
.agent-row .row-btn {
  background: none;
  border: none;
  color: var(--lens-fg-faint);
  cursor: pointer;
  padding: 2px;
  display: inline-flex;
  border-radius: 6px;
}
.agent-row .row-btn:hover {
  color: var(--lens-fg);
  background: var(--lens-surface);
}
.agent-row .row-btn.danger:hover {
  color: #ef9a9a;
}
.agent-row .row-btn:disabled {
  opacity: 0.4;
  cursor: default;
}
.agent-row .row-btn mat-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
}

.lens-hint {
  font-size: 12px;
  color: var(--lens-fg-soft);
  margin: 12px 0 4px 0;
}
.lens-hint strong {
  color: var(--lens-fg-soft);
  font-weight: 600;
}

.lane-select {
  background: var(--lens-surface);
  color: #fff;
  border: 1px solid var(--lens-line);
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 13px;
  outline: none;
  cursor: pointer;
  width: 100%;
  min-width: 0;
}
.lane-select:focus {
  border-color: rgba(144, 202, 249, 0.6);
}
.lane-select:disabled {
  opacity: 0.5;
  cursor: default;
}
.lane-select option {
  background: #1c2230;
  color: #fff;
}

/* Mode badge — matches the credential-pool cue */
.mode-badge {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.02em;
  padding: 2px 8px;
  border-radius: 999px;
  color: #90caf9;
  background: rgba(144, 202, 249, 0.12);
  border: 1px solid rgba(144, 202, 249, 0.25);
  white-space: nowrap;
}
.mode-badge.metered {
  color: #ffb74d;
  background: rgba(255, 183, 77, 0.12);
  border-color: rgba(255, 183, 77, 0.3);
}
.mode-badge.unbound {
  color: var(--lens-fg-faint);
  background: var(--lens-surface);
  border-color: var(--lens-line);
}

.saving-spin {
  font-size: 18px;
  height: 18px;
  width: 18px;
  color: var(--lens-fg-soft);
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.agents-empty {
  margin-top: 12px;
  font-size: 12.5px;
  color: var(--lens-fg-soft);
}

/* Pool tuple dropdown (mat-select outside a form-field): lane-select look */
.agent-binding .pool-select {
  min-width: 260px;
  max-width: 340px;
  padding: 6px 12px;
  border: 1px solid var(--lens-line);
  border-radius: 8px;
  font-size: 13px;
}

/* Tuple rows in the overlay panel: credential as subtle property */
::ng-deep .model-select-panel .pool-cred {
  opacity: 0.55;
  font-size: 0.85em;
}

.scope-cluster {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: 10px;
}

.unscoped-hint {
  font-size: 11px;
  opacity: 0.55;
}

.scope-btn {
  font-size: 11px;
  background: transparent;
  border: 1px solid rgba(97, 175, 239, 0.55);
  border-radius: 999px;
  color: #61afef;
  cursor: pointer;
  padding: 2px 10px;
  white-space: nowrap;
}
.scope-btn:hover {
  background: rgba(97, 175, 239, 0.12);
}
.scope-btn[disabled] {
  opacity: 0.4;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/app/components/settings/agents-lens/agents-lens.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;yEAAA;AAGA;EACE,8BAAA;EACA,mCAAA;EACA,oCAAA;EACA,oCAAA;EACA,gCAAA;EACA,oCAAA;AAEF;;AAAA;EACE,oCAAA;EACA,yCAAA;EACA,0CAAA;EACA,0CAAA;EACA,sCAAA;EACA,yCAAA;AAGF;;AAAA;EAAQ,cAAA;AAIR;;AAFA;EACE,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,+BAAA;EACA,kCAAA;AAKF;AAHE;EACE,uCAAA;EACA,qCAAA;AAKJ;;AADA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAIF;AAFE;EAAe,cAAA;EAAgB,cAAA;AAMjC;AALE;EAAmB,aAAA;EAAe,sBAAA;EAAwB,cAAA;EAAgB,YAAA;AAW5E;AAVE;EAAoB,gBAAA;EAAkB,eAAA;EAAiB,qBAAA;AAezD;AAdE;EAAqB,iBAAA;EAAmB,0BAAA;AAkB1C;;AAfA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAkBF;;AAfA;EACE;8DAAA;EAEA,aAAA;EACA,4DAAA;EACA,mBAAA;EACA,SAAA;EACA,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,+BAAA;EAEA;2EAAA;AAkBF;AAhBE;EAAY,cAAA;EAAgB,aAAA;EAAe,sBAAA;EAAwB,YAAA;AAsBrE;AArBE;EACE,gBAAA;EAAkB,eAAA;EAAiB,qBAAA;EACnC,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;AA2B/C;AAzBE;EACE,eAAA;EAAiB,2BAAA;EACjB,sDAAA;EACA,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;AA8B/C;AA5BE;EAAgB,gCAAA;AA+BlB;AA9BE;EAAgB,cAAA;EAAgB,iBAAA;AAkClC;AAjCE;EAAgB,cAAA;AAoClB;AAnCE;EACE,cAAA;EAAgB,aAAA;EAAe,mBAAA;EAAqB,yBAAA;EAA2B,QAAA;AAyCnF;AAvCE;EAAiB,cAAA;EAAgB,aAAA;EAAe,QAAA;AA4ClD;AA1CE;EACE,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;AA4CJ;AA3CI;EAAU,qBAAA;EAAuB,+BAAA;AA+CrC;AA9CI;EAAiB,cAAA;AAiDrB;AAhDI;EAAa,YAAA;EAAc,eAAA;AAoD/B;AAnDI;EAAW,eAAA;EAAiB,YAAA;EAAc,WAAA;AAwD9C;;AAnDA;EACE,eAAA;EACA,0BAAA;EACA,oBAAA;AAsDF;AArDE;EAAS,0BAAA;EAA4B,gBAAA;AAyDvC;;AAtDA;EACE,+BAAA;EACA,WAAA;EACA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAyDF;AAvDE;EAAU,sCAAA;AA0DZ;AAzDE;EAAa,YAAA;EAAc,eAAA;AA6D7B;AA5DE;EAAS,mBAAA;EAAqB,WAAA;AAgEhC;;AA7DA,iDAAA;AACA;EACE,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,qCAAA;EACA,2CAAA;EACA,mBAAA;AAgEF;AA9DE;EACE,cAAA;EACA,oCAAA;EACA,qCAAA;AAgEJ;AA7DE;EACE,2BAAA;EACA,+BAAA;EACA,8BAAA;AA+DJ;;AA3DA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;EACA,kCAAA;AA8DF;;AA5DA;EAAkB;IAAK,yBAAA;EAiErB;AACF;AAhEA;EACE,gBAAA;EACA,iBAAA;EACA,0BAAA;AAkEF;;AA/DA,4EAAA;AACA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;AAkEF;;AA/DA,mEAAA;AACA;EACE,aAAA;EACA,iBAAA;AAkEF;;AA/DA;EAAiB,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,iBAAA;AAsEtE;;AArEA;EAAiB,eAAA;EAAiB,aAAA;AA0ElC;;AAzEA;EAAa,eAAA;EAAiB,uBAAA;EAAyB,0CAAA;EAAwC,oBAAA;EAAsB,cAAA;EAAgB,eAAA;EAAiB,iBAAA;EAAmB,mBAAA;AAoFzK;AAnFE;EAAU,oCAAA;AAsFZ;AArFE;EAAc,YAAA;EAAa,eAAA;AAyF7B","sourcesContent":["/* Theme-aware palette (2026-08-13): the Setup lenses were hardcoded to\n   dark-mode whites and vanished in light mode. Component vars, dark values\n   under :host-context(.dark) — matches the app's :root.dark switching. */\n:host {\n  --lens-fg: rgba(0, 0, 0, 0.87);\n  --lens-fg-soft: rgba(0, 0, 0, 0.55);\n  --lens-fg-faint: rgba(0, 0, 0, 0.38);\n  --lens-hover-bg: rgba(0, 0, 0, 0.05);\n  --lens-line: rgba(0, 0, 0, 0.12);\n  --lens-surface: rgba(0, 0, 0, 0.025);\n}\n:host-context(.dark) {\n  --lens-fg: rgba(255, 255, 255, 0.92);\n  --lens-fg-soft: rgba(255, 255, 255, 0.55);\n  --lens-fg-faint: rgba(255, 255, 255, 0.38);\n  --lens-hover-bg: rgba(255, 255, 255, 0.06);\n  --lens-line: rgba(255, 255, 255, 0.12);\n  --lens-surface: rgba(255, 255, 255, 0.03);\n}\n\n:host { display: block; }\n\n.setup-item {\n  border: 1px solid var(--lens-line);\n  border-radius: 12px;\n  padding: 18px 20px;\n  background: var(--lens-surface);\n  transition: border-color 0.2s ease;\n\n  &.complete {\n    border-color: rgba(102, 187, 106, 0.35);\n    background: rgba(102, 187, 106, 0.04);\n  }\n}\n\n.setup-item-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n\n  .status-icon { color: #66bb6a; flex: 0 0 auto; }\n  .setup-item-info { display: flex; flex-direction: column; flex: 1 1 auto; min-width: 0; }\n  .setup-item-title { font-weight: 600; font-size: 15px; color: var(--lens-fg); }\n  .setup-item-status { font-size: 12.5px; color: var(--lens-fg-soft); }\n}\n\n.agent-rows {\n  margin-top: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.agent-row {\n  /* name (fills) | badge lane (fixed) | dropdown lane (fixed) — keeps badges and\n     dropdowns aligned in vertical columns across every row. */\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 100px 160px 180px auto;\n  align-items: center;\n  gap: 12px;\n  border: 1px solid var(--lens-line);\n  border-radius: 10px;\n  padding: 10px 14px;\n  background: var(--lens-surface);\n\n  /* Explicit lane placement so a hidden badge (subscription rows) leaves its\n     column empty rather than collapsing and shifting the dropdowns left. */\n  .agent-id { grid-column: 1; display: flex; flex-direction: column; min-width: 0; }\n  .agent-name {\n    font-weight: 600; font-size: 14px; color: var(--lens-fg);\n    overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n  }\n  .agent-sub {\n    font-size: 11px; color: var(--lens-fg-faint);\n    font-family: ui-monospace, \"SF Mono\", Menlo, monospace;\n    overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n  }\n  .backend-hint { color: rgba(144, 202, 249, 0.65); }\n  > .mode-badge { grid-column: 2; justify-self: end; }\n  .model-select { grid-column: 3; }\n  .agent-binding {\n    grid-column: 4; display: flex; align-items: center; justify-content: flex-end; gap: 8px;\n  }\n  .agent-actions { grid-column: 5; display: flex; gap: 4px; }\n\n  .row-btn {\n    background: none;\n    border: none;\n    color: var(--lens-fg-faint);\n    cursor: pointer;\n    padding: 2px;\n    display: inline-flex;\n    border-radius: 6px;\n    &:hover { color: var(--lens-fg); background: var(--lens-surface); }\n    &.danger:hover { color: #ef9a9a; }\n    &:disabled { opacity: 0.4; cursor: default; }\n    mat-icon { font-size: 18px; height: 18px; width: 18px; }\n  }\n\n}\n\n.lens-hint {\n  font-size: 12px;\n  color: var(--lens-fg-soft);\n  margin: 12px 0 4px 0;\n  strong { color: var(--lens-fg-soft); font-weight: 600; }\n}\n\n.lane-select {\n  background: var(--lens-surface);\n  color: #fff;\n  border: 1px solid var(--lens-line);\n  border-radius: 8px;\n  padding: 6px 10px;\n  font-size: 13px;\n  outline: none;\n  cursor: pointer;\n  width: 100%;\n  min-width: 0;\n\n  &:focus { border-color: rgba(144, 202, 249, 0.6); }\n  &:disabled { opacity: 0.5; cursor: default; }\n  option { background: #1c2230; color: #fff; }\n}\n\n/* Mode badge — matches the credential-pool cue */\n.mode-badge {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  padding: 2px 8px;\n  border-radius: 999px;\n  color: #90caf9;\n  background: rgba(144, 202, 249, 0.12);\n  border: 1px solid rgba(144, 202, 249, 0.25);\n  white-space: nowrap;\n\n  &.metered {\n    color: #ffb74d;\n    background: rgba(255, 183, 77, 0.12);\n    border-color: rgba(255, 183, 77, 0.3);\n  }\n\n  &.unbound {\n    color: var(--lens-fg-faint);\n    background: var(--lens-surface);\n    border-color: var(--lens-line);\n  }\n}\n\n.saving-spin {\n  font-size: 18px;\n  height: 18px;\n  width: 18px;\n  color: var(--lens-fg-soft);\n  animation: spin 1s linear infinite;\n}\n@keyframes spin { to { transform: rotate(360deg); } }\n\n.agents-empty {\n  margin-top: 12px;\n  font-size: 12.5px;\n  color: var(--lens-fg-soft);\n}\n\n/* Pool tuple dropdown (mat-select outside a form-field): lane-select look */\n.agent-binding .pool-select {\n  min-width: 260px;\n  max-width: 340px;\n  padding: 6px 12px;\n  border: 1px solid var(--lens-line);\n  border-radius: 8px;\n  font-size: 13px;\n}\n\n/* Tuple rows in the overlay panel: credential as subtle property */\n::ng-deep .model-select-panel .pool-cred {\n  opacity: 0.55;\n  font-size: 0.85em;\n}\n\n.scope-cluster { display: inline-flex; align-items: center; gap: 8px; margin-left: 10px; }\n.unscoped-hint { font-size: 11px; opacity: .55; }\n.scope-btn { font-size: 11px; background: transparent; border: 1px solid rgba(97,175,239,.55); border-radius: 999px; color: #61afef; cursor: pointer; padding: 2px 10px; white-space: nowrap;\n  &:hover { background: rgba(97,175,239,.12); }\n  &[disabled] { opacity: .4; cursor: default; } }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
